<template>
    <div>
      <div class="front front--page">
        <div class="container">
          <h1 class="title title--big color--white">Nuestro Equipo</h1>
          <div class="separator separator--white"></div>
        </div>
      </div>
      
      <div class="page-body">
        <div class="container">
            <h2 class="color--light-blue">En Varelab se destacan profesionales de primera línea, técnicos y personal administrativo. Todos a disposición del paciente para guiarlo y cuidarlo.</h2>
      
            <div class="page-block">
              <div class="media">
                <div class="media-left" href="#">
                  <img class="media-object" src="#" alt="Image">
                </div>
                <div class="media-body">
                  <div class="montserrat">
                    <h4>Hernán <b>Elemberg</b></h4>
                    <h5>Bioquimico</h5>
                  </div>
                  <p class="color--pink">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Totam quisquam nulla soluta sunt! Repellat corporis rerum nulla, asperiores possimus voluptate. Adipisci doloribus quidem nam eveniet quia consequatur blanditiis, iure amet!
                  </p>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'estandares'
}
</script>
<!-- styling for the component -->
<style>

</style>


// WEBPACK FOOTER //
// src/components/Institucional/Equipo.vue